'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UITable from 'UIComponents/table/UITable';
import { getOperatingSystem } from 'DesignData/helpers/osHelpers';
import H2 from 'UIComponents/elements/headings/H2';

const i18nKey = key => `designManager.keybindings.${key}`;

const KEYS = {
  editor: ['save', 'undo', 'redo', 'publish'],
  finder: ['fileSearch'],
  general: ['multiSelect', 'contextMenu']
};

class KeyboardShortcutsListing extends PureComponent {
  constructor(props) {
    super(props);
    this.renderCategoryTable = this.renderCategoryTable.bind(this);
  }

  renderCategoryTable(categoryKey) {
    const rows = KEYS[categoryKey].map(key => {
      return /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(`${categoryKey}.${key}.action`)
          })
        }), /*#__PURE__*/_jsx("td", {
          className: "text-center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(`${categoryKey}.${key}.shortcut.${getOperatingSystem()}`)
          })
        })]
      }, key);
    });
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("h3", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`${categoryKey}.header`)
        })
      }), /*#__PURE__*/_jsxs(UITable, {
        className: "shortcuts-table",
        children: [/*#__PURE__*/_jsxs("colgroup", {
          children: [/*#__PURE__*/_jsx("col", {
            width: "65%"
          }), /*#__PURE__*/_jsx("col", {
            width: "35%"
          })]
        }), /*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('tableHeaders.action')
              })
            }), /*#__PURE__*/_jsx("th", {
              className: "text-center",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('tableHeaders.shortcut')
              })
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: rows
        })]
      })]
    }, categoryKey);
  }

  render() {
    const {
      setIsKeyboardShortcutsListingShowing
    } = this.props;
    const tables = Object.keys(KEYS).map(this.renderCategoryTable);
    return /*#__PURE__*/_jsxs(UIModalPanel, {
      className: "ide-keyboard-shortcuts-listing",
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: () => setIsKeyboardShortcutsListingShowing(false)
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(`header.${getOperatingSystem()}`)
          })
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: tables
      })]
    });
  }

}

KeyboardShortcutsListing.propTypes = {
  setIsKeyboardShortcutsListingShowing: PropTypes.func.isRequired
};
export default KeyboardShortcutsListing;